import { productDescriptions } from './productDescriptions';

const CATEGORY_LABELS = {
  'Pallaet Truck': 'Pallet Truck',
  'Aerial Lift': 'Aerial Lift',
  'Stacker': 'Stacker',
  'Scissor Lift': 'Scissor Lift',
  'Floor Crane': 'Floor Crane',
  'Dock Leveller': 'Dock Leveller',
  'Goods Lift': 'Goods Lift',
  'Drum Equipment': 'Drum Handling',
  'Platform Trolley': 'Platform Trolley',
  'Trolley': 'Trolley',
};

const formatModelCode = (filename) =>
  filename
    .replace(/\.(png|jpe?g|webp)$/i, '')
    .replace(/_/g, '-')
    .toUpperCase();

const formatCategory = (folder) =>
  CATEGORY_LABELS[folder] || folder.replace(/Pallaet/, 'Pallet');

const productImages = require.context(
  '../assets/Website Photos',
  true,
  /\.(png|jpe?g|webp)$/i
);

export const buildAssetProducts = () =>
  productImages
    .keys()
    .map((key) => {
      const image = productImages(key);
      const segments = key.split('/');
      const folder = segments[segments.length - 2] || '';
      const filename = segments[segments.length - 1];
      const name = formatModelCode(filename);
      const category = formatCategory(folder);
      const copy = productDescriptions[name] || {};

      return {
        id: 0,
        name,
        category,
        image: typeof image === 'string' ? image : image.default || image,
        paragraphs: copy.paragraphs || [],
        features: copy.features || [],
      };
    })
    .sort((a, b) => {
      const byCat = a.category.localeCompare(b.category);
      return byCat !== 0 ? byCat : a.name.localeCompare(b.name);
    })
    .map((p, i) => ({ ...p, id: i + 1 }));
